import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "placeholder", "input"]

  // The saved picture may be missing (file not on disk in development, deleted upload):
  // show the placeholder instead of a broken image. The image can fail before connect.
  connect () {
    const image = this.previewTarget
    if (image.getAttribute("src") && image.complete && image.naturalWidth === 0) this.showPlaceholder()
  }

  showPlaceholder () {
    this.previewTarget.hidden = true
    if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = false
  }

  preview () {
    const file = this.inputTarget.files?.[0]
    if (!file || !file.type.startsWith("image/")) return

    const reader = new FileReader()
    reader.onload = (event) => {
      this.previewTarget.src = event.target.result
      this.previewTarget.hidden = false
      if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = true
    }
    reader.readAsDataURL(file)
  }
}
